import React, { Component } from "react";
import { RichText } from "prismic-reactjs";
import { linkResolver } from "../prismic-configuration";
import { format } from "date-fns";

export class Event extends Component {
  render() {
    const { event } = this.props;

    return (
      <div className="mb-4">
        <p className="mb-1">
          <a href={linkResolver(event)} className="text-orange">
            <strong>{RichText.asText(event.data.title)}</strong>
          </a>
        </p>
        <p className="mb-1">
          <i className="fas fa-calendar-alt" />{" "}
          {format(event.data.date, "DD MMMM YY")}
        </p>
        {event.data.excerpt.length !== 0 && (
          <p>{RichText.asText(event.data.excerpt, linkResolver)}</p>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Event.js